import { LanguageCode } from '@kouto/types';
import { replaceLanguageCodeInUrl } from 'components/helpers';
import { HYATT_AUTH_REDIRECT_URL } from '../../consts/HyattLMSConsts';

export const getHyattSignInUrl = (
  languageCode: LanguageCode = LanguageCode.EN_US,
) => {
  const clientId = process.env.HYATT_CLIENT_ID;
  const hyattSignInUrl = replaceLanguageCodeInUrl(
    process.env.HYATT_SIGN_IN_URL,
    languageCode,
  );
  const redirectURL = `${hyattSignInUrl}?client_id=${clientId}&response_type=code&redirect_uri=${HYATT_AUTH_REDIRECT_URL}`;
  return redirectURL;
};

export const getHyattJoinUrl = (
  languageCode: LanguageCode = LanguageCode.EN_US,
) => {
  try {
    const clientId = process.env.HYATT_CLIENT_ID;
    const hyattJoinUrl = replaceLanguageCodeInUrl(
      process.env.HYATT_JOIN_URL,
      languageCode,
    );
    const redirectURL = `${hyattJoinUrl}?client_id=${clientId}&response_type=code&redirect_uri=${HYATT_AUTH_REDIRECT_URL}`;
    return redirectURL;
  } catch (error) {
    console.error('Error in getHyattJoinUrl:', error);
    throw error;
  }
};
